import React from 'react';
import moment from 'moment';
import {ORDER_STATUS, DEFAULT_TRACKER_FUTURE_TIME_FORMAT, DEFAULT_TRACKER_TIME_FORMAT} from '../constants/constant';

export const getOrderTrackerInfo = (orderStatus, fulfillAt, isDelivery, tel, eta) => {
  let titleId;
  let descriptionId;
  let descriptionValue;
  const telLink = `tel:${tel}`;

  switch (orderStatus.status) {
    case ORDER_STATUS.CONFIRMED: {
      titleId = 'confirmation.confirm';
      descriptionId = fulfillAt ? 'confirmation.futureOrderInfo' : 'confirmation.confirmInfo';
      descriptionValue = fulfillAt ?
        {
          time: moment(fulfillAt).format(DEFAULT_TRACKER_FUTURE_TIME_FORMAT),
          eta
        } : {
          time: moment(orderStatus.timestamp).format(DEFAULT_TRACKER_TIME_FORMAT),
          eta
        };
      break;
    }
    case ORDER_STATUS.CANCELLED:
    case ORDER_STATUS.CANCELLATION_PENDING: {
      titleId = 'confirmation.cancel';
      descriptionId = 'confirmation.cancelInfo';
      descriptionValue = {
        tel: <a href={telLink}>{tel}</a>
      };
      break;
    }
    case ORDER_STATUS.READY: {
      titleId = 'confirmation.ready';
      descriptionId = isDelivery ? 'confirmation.readyForDelivery' : 'confirmation.readyForCollection';
      break;
    }
    case ORDER_STATUS.COMPLETED: {
      titleId = 'confirmation.completed';
      descriptionId = 'confirmation.completedInfo';
      break;
    }
    default:
      titleId = 'confirmation.ordered';
      descriptionId = fulfillAt ? 'confirmation.orderedFutureInfo' : 'confirmation.orderedInfo';
      descriptionValue = fulfillAt ?
        {time: moment(fulfillAt).format(DEFAULT_TRACKER_FUTURE_TIME_FORMAT)} : {};
  }
  return {
    titleId,
    descriptionId,
    descriptionValue
  };
};



// WEBPACK FOOTER //
// ./helpers/orderTracker.helper.js